import {useEffect, useRef} from "react";
import {PROD_API_URL} from "../constants/constants";
import toast from "react-hot-toast";
import {errorToast} from "./toastCSS";

export const BLOCKCHAIN_ETH = 'ETHEREUM';
export const BLOCKCHAIN_POLYGON = 'POLYGON';
export const BLOCKCHAIN_ARBITRUM = 'ARBITRUM';
export const BLOCKCHAIN_SUPRA = 'SUPRA';
export const BLOCKCHAIN_SUI = 'SUI';
export const BLOCKCHAIN_AVALANCHE = 'AVALANCHE';
export const BLOCKCHAIN_DYMENSION = 'DYMENSION';
export const BLOCKCHAIN_SKALE = 'SKALE';
export const BLOCKCHAIN_BASE = 'BASE';
export const BLOCKCHAIN_SOLANA = 'SOLANA';
export const BLOCKCHAIN_CLASSIFIED = 'CLASSIFIED';
export const BLOCKCHAIN_UNKNOWN = 'UNKNOWN';

export const calculateBlockchain = (ido) => {
    if (ido?.isEthereum === true) {
        return BLOCKCHAIN_ETH;
    }
    if (ido?.isPolygon === true) {
        return BLOCKCHAIN_POLYGON;
    }

    if (ido?.isArbitrum === true) {
        return BLOCKCHAIN_ARBITRUM;
    }

    if (ido?.isSupra) {
        return BLOCKCHAIN_SUPRA;
    }

    if (ido?.isSol === true) {
        return BLOCKCHAIN_SOLANA;
    }

    if (ido?.isSUI === true) {
        return BLOCKCHAIN_SUI;
    }

    if (ido?.isAvalanche === true) {
        return BLOCKCHAIN_AVALANCHE;
    }

    if (ido?.isClassified === true) {
        return 'CLASSIFIED';
    }

    return 'UNKNOWN';
};

export const hasValue = (s) => {
    return s !== null && typeof s !== 'undefined' && s !== '' && s.length !== 0;
}
export const useDebouncedEffect = (effect, delay, deps) => {
    const callback = useRef();
    callback.current = effect;

    useEffect(() => {
        const handler = setTimeout(() => {
            if (callback.current) {
                callback.current();
            }
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [...(deps || []), delay]);
};

export const walletFormatting = (wallet, sliceOverride = 6) => {
    const isMobile = window.screen.width < 1000;
    if (wallet) {
        return wallet.slice(0, isMobile ? 4 : sliceOverride) + '...' + wallet.slice(wallet.length - (isMobile ? 4 : sliceOverride));
    }

    return 'Missing Wallet';
}

export const saveSingleCadetValue = async (body) => {
    try {
        return await fetch(PROD_API_URL + '/cadetInfo/saveSingle', {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "accept": "*",
                'Cookie': 'sails.sid=s%3Avh-tedPOHnJh8E0RhjeC820oxrGU6DwJ.5AwSIniluWQcyz%2B6f7UJ8fDteBEX08UIFEXBltW6tfc'
            },
            body: JSON.stringify(body),
        });
    } catch (e) {
        toast('Error saving cadet info', errorToast);
        console.error(e);
    }
}

export const handleImageUpload = async (ImageFileInfo, category, fileName) => {
    const uploadData = await fetch( PROD_API_URL + "/settings/getUploadUrl", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            mime: ImageFileInfo.type,
            ext: ImageFileInfo.name.split('.').pop(),
            category,
            filename: fileName,
        }),
    });
    const { uploadUrl, key } = await uploadData.json();

    const resp = await fetch(uploadUrl, {
        method: "PUT",
        body: ImageFileInfo
    });

    if (!resp.ok) {
        throw new Error("Failed to upload image");
    }

    return "https://images.starlaunch.com" + "/" + key;
}